export default __webpack_public_path__ + "static/media/chat-icon.dd592ed6.svg";